import { render, staticRenderFns } from "./CompanyNotesModal.vue?vue&type=template&id=e587f87c&scoped=true&"
import script from "./CompanyNotesModal.vue?vue&type=script&lang=js&"
export * from "./CompanyNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e587f87c",
  null
  
)

export default component.exports